import produce from 'immer'
import { combineReducers } from 'redux'
import { fetchTeamsAsync } from 'shared/store/actions/teams'
import { Team } from 'shared/typings/teams/Team'

import { AnyRootAction, createReducer } from 'typesafe-actions'

const byId = createReducer<Record<number, Team>, AnyRootAction>({}).handleAction(
  [fetchTeamsAsync.success],
  (state, action: { payload: Team[] }) => {
    return produce(state, (draft) => {
      action.payload.forEach((team) => {
        draft[team.id] = team
      })
    })
  }
)

export default combineReducers({
  byId,
})
